
import React from 'react';
import { Link } from 'react-router-dom';
import { allNews as news } from '../data/newsData';


const NewsDetailPage: React.FC = () => (
    <div className="pt-20 bg-gray-50 min-h-screen">
        <header className="bg-white py-16 text-center border-b">
            <div className="container mx-auto px-6">
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#3aabd2]">News</h1>
                <p className="mt-2 text-lg text-gray-600">お知らせ</p>
            </div>
        </header>
        <section className="py-20">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {news.map(item => (
                        <Link key={item.id} to={item.link} className="block bg-white rounded-lg shadow-md overflow-hidden group border border-gray-200 hover:shadow-xl hover:border-[#3aabd2] transition-all duration-300 transform hover:-translate-y-2">
                           <div className="h-48 bg-gray-200 flex items-center justify-center">
                               <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                           </div>
                           <div className="p-6">
                                <p className="text-sm text-gray-500 mb-2">{item.date}</p>
                                <h3 className="text-lg font-bold text-gray-800 group-hover:text-[#3aabd2] transition-colors duration-300">{item.title}</h3>
                           </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    </div>
);

export default NewsDetailPage;